import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const ArrowUpRight: FC<Props> = ({ width = 25, height = 24, className, color = "#FEFCF6" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 19 18"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.125 3.375V4.5H13.2069L3.875 13.8319L4.66812 14.625L14 5.29312V12.375H15.125V3.375H6.125Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowUpRight;
